import { connect } from "react-redux";
import Modal from "./Modal";
import { hideModal } from "../../actions/modalActions";
import { cancelWidgetEdit } from "../../actions/layoutActions";
import {
  recordEvent,
  eventCategories
} from "../../utils/googleAnalyticsEvents";
import type { AppDispatch, RootState } from "../../store";

const mapStateToProps = (state: RootState) => {
  const { isModalVisible, modalType, subType } = state.modal;
  const { editWidgetIdentifiers, widgetList } = state.layouts;
  return {
    isModalVisible,
    modalType,
    subType,
    editWidgetIdentifiers,
    widgetList
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    closeModal: () => {
      recordEvent(
        "Modal Closed",
        eventCategories.GENERAL_APP_ACTION,
        "Modal Closed"
      );
      dispatch(hideModal());
      dispatch(cancelWidgetEdit());
    }
  };
};

const ModalContainer = connect(mapStateToProps, mapDispatchToProps)(Modal);

export default ModalContainer;
